import { action, computed, makeObservable, observable } from "mobx";
import toast from "react-hot-toast";
import URLConstants from "../../constants/url-constants";
import { getEffectiveDateTime, getEffectiveMonthYear } from "../../helpers/date-time-helper";
import { IObservableInitialState } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import {
  ICustomerSalesRatioList,
  ICustomerSalesRatioVM,
  ICustomerToTreatmentProductDailySales,
  IDailyTotallingFilter,
  IMonthlyTotallingFilter,
  IPaymentRow,
  ISaleDetailVM,
  ISaleDetailVMList,
  IStaffSalesDetailList,
  IStaffSalesDetailVM,
  IStaffTotallingFilter,
  ITotallingManagement,
  ITotallingManagementVMs,
  ITransformedRow,
  IWeeklySalesAndPaymentDetailVM,
  IWeeklySalesAndPaymentDetailVMRow,
  IWeeklyTotallingFilter,
} from "../../models/response/ITotallingManagementResponse";
import { formatMessage } from "../../translations/format-message";
import * as baseService from "../service/base-service";
import bookingStatusEnum from "../../constants/enums/booking-status-enum";
import { TimeFormat } from "../../constants/time-picker-constant";
import moment from "moment";
import { ISortingCustom } from "../../models/ISorting";
import { customerSalesRatioInitialState, initialCustomerSalesRatioAccordingToAgeGroupData } from "../initialState/totalling-initial-state";
import { DATE_FORMAT } from "../../constants/constants";
import dayjs from "dayjs";
import { serviceTypeEnum } from "../../constants/enums/service-type-enum";
import { getLanguageFromLocalStorage } from "../../helpers/localstorage-helper";

export class TotallingManagementStore {
  initialStateValue: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };
  dailyTotallingSales: ITotallingManagementVMs = {
    TreatmentVMs: [],
    ProductVMs: [],
    OptionVMs: [],
    PaymentVMs: [],
    CategoryVMS: [],
  };
  dailyTotallingSalesState: IObservableInitialState = {
    ...this.initialStateValue,
  };
  customerToTreatmentProductDailySales: ICustomerToTreatmentProductDailySales[] =
    [];
  customerToTreatmentProductDailySalesState: IObservableInitialState = {
    ...this.initialStateValue,
  };
  customerSalesRatio: ICustomerSalesRatioVM = {...customerSalesRatioInitialState}
  customerSalesRatioState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  dailyTotallingFilter: IDailyTotallingFilter = {
    Date: getEffectiveDateTime(),
    StaffId: -1,
    isFilterActive: false,
    isFilterChanged: false,
    showClear: false,
  };

  weeklySalesDetailCount: ISaleDetailVM[] = [];
  weeklySalesDetailCountState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  weeklySalesAndPaymentDetail: IWeeklySalesAndPaymentDetailVM[] = [];
  weeklySalesAndPaymentDetailState: IObservableInitialState = {
    ...this.initialStateValue,
  };
  
  monthlyTotallingFilter: IMonthlyTotallingFilter = {
    MonthYear: getEffectiveMonthYear(),
    StaffId: -1,
    isFilterActive: false,
    isFilterChanged: false,
    showClear: false,
  };
  
  weeklyTotallingFilter: IWeeklyTotallingFilter = {
    StartDate: moment(new Date()).format(DATE_FORMAT),
    EndDate: moment(new Date()).add(6, "days").format(DATE_FORMAT),
    StaffId: -1,
    isFilterActive: false,
    isFilterChanged: false,
    showClear: false,
  };

  periodTotallingFilter: IWeeklyTotallingFilter = {
    StartDate: "",
    EndDate: "",
    StaffId: -1,
    isFilterActive: false,
    isFilterChanged: false,
    showClear: false,
  };
  
  staffSalesDetail: IStaffSalesDetailVM[] = [];
  staffSalesDetailState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  staffTotallingFilter: IStaffTotallingFilter = {
    StartDate: moment(new Date()).format(DATE_FORMAT),
    EndDate: moment(new Date()).add(6, "days").format(DATE_FORMAT),
    StaffId: -1,
    isFilterActive: false,
    isFilterChanged: false,
    showClear: false,
  };

  constructor() {
    makeObservable(this, {
      initialStateValue: observable,
      dailyTotallingSales: observable,
      dailyTotallingSalesState: observable,
      customerToTreatmentProductDailySales: observable,
      customerToTreatmentProductDailySalesState: observable,
      customerSalesRatio: observable,
      customerSalesRatioState: observable,
      dailyTotallingFilter: observable,
      weeklySalesDetailCount: observable,
      weeklySalesDetailCountState: observable,
      weeklySalesAndPaymentDetail: observable,
      weeklySalesAndPaymentDetailState: observable,
      weeklyTotallingFilter: observable,
      monthlyTotallingFilter: observable,
      periodTotallingFilter: observable,
      staffSalesDetail: observable,
      staffSalesDetailState: observable,
      staffTotallingFilter: observable,
      GetDailyTotallingSalesService: action,
      GetCustomerToTreatmentProductDailySalesService: action,
      GetCustomerSalesRatioService: action,
      GetWeeklySalesDetailCountService: action,
      GetWeeklySalesAndPaymentDetailService: action,
      GetStaffSalesDetailService: action,
      resetDailyTotallingSalesState: action,
      resetCustomerToTreatmentProductDailySalesState: action,
      setDailyTotallingFilterDetail: action,
      resetDailyTotallingFilterDetail: action,
      setWeeklyTotallingFilterDetail: action,
      resetWeeklyTotallingFilterDetail: action,
      setStaffTotallingFilterDetail: action,
      resetStaffTotallingFilterDetail: action,
      setMonthlyTotallingFilterDetail: action,
      setPeriodTotallingFilterDetail: action,
      resetMonthlyTotallingFilterDetail: action,
      resetCustomerSalesRatioState: action,
      resetWeeklySalesDetailCountState: action,
      resetWeeklySalesAndPaymentDetailState: action,
      resetStaffSalesDetailState: action,
      resetPeriodTotallingFilterDetail: action,
      getDailyTotallingSales: computed,
      getCustomerToTreatmentProductDailySales: computed,
      getCustomerSalesRatio: computed,
      getweeklySalesDetailCount: computed,
      getMonthlySalesDetailCount: computed,
      getMonthlySalesAndPaymentDetail: computed,
      getWeeklySalesAndPaymentDetail: computed,
      getStaffSalesDetail: computed,
    });
  }

  GetDailyTotallingSalesService = (
    storeId: number,
    headquarterId: number,
    filter: IDailyTotallingFilter
  ) => {
    this.dailyTotallingSalesState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
    urlParams.append("Date", String(filter.Date) + " 00:00");
    if (filter.StaffId > 0) {
      urlParams.append("staffId", String(filter.StaffId));
    }
    const url =
      URLConstants.GetDailyTotallingSales + "?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<ITotallingManagementVMs>>
        ) => {
          if (response.data.Error) {
            this.dailyTotallingSalesState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.dailyTotallingSales = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.dailyTotallingSalesState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.dailyTotallingSalesState.inProgress = false;
        })
      );
  };

  resetDailyTotallingSalesState = () => {
    this.dailyTotallingSalesState = { ...this.initialStateValue };
    this.dailyTotallingSales = {
      TreatmentVMs: [],
      ProductVMs: [],
      OptionVMs: [],
      PaymentVMs: [],
      CategoryVMS: [],
    };
  };

  get getDailyTotallingSales(): ITotallingManagement {
    const data = this.dailyTotallingSales;

    if (!data) {
      return {
        treatments: [],
        options: [],
        products: [],
        treatmentTotal: 0,
        productTotal: 0,
        grandTotal: 0,
        totalDiscount: 0,
        totalPaidAmount: 0,
        payments: {},
      };
    }
    let totalDiscount = 0;
    let totalTreatmentDiscount = 0;
    let totalProductDiscount = 0;
    const mergedOptions = Object.values(
      data.OptionVMs.reduce((acc, opt) => {
        totalDiscount = totalDiscount + opt.DiscountCash;
        if (!acc[opt.OptionId]) {
          acc[opt.OptionId] = { ...opt };
        } else {
          acc[opt.OptionId].NumberOfRepitition += opt.NumberOfRepitition;
        }
        return acc;
      }, {} as Record<number, (typeof data.OptionVMs)[0]>)
    );
    const optionTotal = mergedOptions.reduce(
      (sum, t) => sum + t.Price,
      0
    );

    const treatmentTotal = data.TreatmentVMs.reduce(
      (sum, t) => sum + t.Price ,
      0
    );
    const productTotal = data.ProductVMs.reduce(
      (sum, p) => sum + p.Price,
      0
    );
    let treatmentOptionTotal = treatmentTotal + optionTotal;
    let grandTotal = treatmentTotal + optionTotal + productTotal;

    const getCategoryPath = (itemType: string, itemId: number): string => {
      const category = data.CategoryVMS.find(
        (c) => c.ItemType === itemType && c.ItemId === itemId
      );
      return category ? category.CategoryName.join(" > ") : "";
    };

    const treatments: ITransformedRow[] = data.TreatmentVMs.map((t) => {
      const percent = ((t.Price) / grandTotal) * 100;
      const displayedPercent =
        percent % 1 === 0 ? `${percent.toFixed(0)}%` : `${percent.toFixed(1)}%`;
      totalDiscount = totalDiscount + t.DiscountCash;
      totalTreatmentDiscount = totalTreatmentDiscount + t.DiscountCash;
      return {
        name: t.TreatmentName,
        amount: t.Price,
        percentage: grandTotal ? displayedPercent : "0%",
        repetitions: t.NumberOfRepitition,
        categoryName: getCategoryPath("Treatment", t.TreatmentId),
      };
    });

    const options: ITransformedRow[] = mergedOptions.map((t) => {
      const percent = ((t.Price) / grandTotal) * 100;
      const displayedPercent =
        percent % 1 === 0 ? `${percent.toFixed(0)}%` : `${percent.toFixed(1)}%`;
      totalTreatmentDiscount = totalTreatmentDiscount + t.DiscountCash;
      return {
        name: t.OptionName.includes("_")
          ? t.OptionName.substring(t.OptionName.indexOf("_") + 1)
          : t.OptionName,
        amount: t.Price,
        percentage: grandTotal ? displayedPercent : "0%",
        repetitions: t.NumberOfRepitition,
        categoryName: "",
      };
    });

    const products: ITransformedRow[] = data.ProductVMs.map((p) => {
      const percent = ((p.Price) / grandTotal) * 100;
      const displayedPercent =
        percent % 1 === 0 ? `${percent.toFixed(0)}%` : `${percent.toFixed(1)}%`;
      totalDiscount = totalDiscount + p.DiscountCash;
      totalProductDiscount = totalProductDiscount + p.DiscountCash;
      return {
        name: p.ProductName,
        amount: p.Price,
        percentage: grandTotal ? displayedPercent : "0%",
        repetitions: p.NumberOfRepitition,
        categoryName: getCategoryPath("Product", p.ProductId),
      };
    });

    const payments: IPaymentRow = {};
    data.PaymentVMs.forEach((pm) => {
      payments[pm.Name] = pm.Amount;
    });
    const totalPaidAmount = grandTotal;
    grandTotal = grandTotal;

    return {
      treatments,
      options,
      products,
      treatmentTotal: treatmentOptionTotal,
      productTotal: productTotal,
      grandTotal,
      totalDiscount,
      totalPaidAmount,
      payments,
    };
  }

  GetCustomerToTreatmentProductDailySalesService = (
    storeId: number,
    headquarterId: number,
    filter: IDailyTotallingFilter,
    sorting: ISortingCustom
  ) => {
    this.customerToTreatmentProductDailySalesState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
    if (filter.StaffId > 0) {
      urlParams.append("staffId", String(filter.StaffId));
    }
    urlParams.append("Date", String(filter.Date) + " 00:00");
    urlParams.append("column", sorting.column);
    urlParams.append("OrderBy", sorting.orderBy ? sorting.orderBy : "desc");
    const url =
      URLConstants.GetCustomerToTreatmentProductDailySales +
      "?" +
      urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ICustomerToTreatmentProductDailySales[]>>) => {
        if (response.data.Error) {
          this.customerToTreatmentProductDailySalesState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.customerToTreatmentProductDailySales = response.data.Data ? response.data.Data : [];
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.customerToTreatmentProductDailySalesState.error = err;
      })
      .finally(
        action(() => {
          this.customerToTreatmentProductDailySalesState.inProgress = false;
        })
      );
  };

  resetCustomerToTreatmentProductDailySalesState = () => {
    this.customerToTreatmentProductDailySalesState = {
      ...this.initialStateValue,
    };
  };

  get getCustomerToTreatmentProductDailySales() {
    return this.customerToTreatmentProductDailySales.map((item) => {
      let statusText = bookingStatusEnum[item.Status];
      const options = item.Options.map((opt) => {
      return {
        ...opt,
        Name: opt.Name.includes("_")
          ? opt.Name.substring(opt.Name.indexOf("_") + 1)
          : opt.Name,
        ItemType: serviceTypeEnum.Option
      };
    });
      let details = [
        ...(item.Treatments || []),
        ...(options || []),
        ...(item.Products || []),
      ];
      let reservationTime = moment(item.ReservationTime, TimeFormat).format(TimeFormat);
      let amountFormatted = item.Amount;
      let customerName = ((item.FirstName !== null && item.FirstName !== "") || (item.LastName !== null && item.LastName !== "")) ? item.LastName + " " + item.FirstName
       : item.LastNameKana + " " + item.FirstNameKana

      return {
        Status: statusText,
        CustomerName: customerName,
        Details: details,
        StaffName: item.StaffName,
        ReservationTime: reservationTime,
        Amount: amountFormatted,
      };
    });
  }

  GetCustomerSalesRatioService = (
    storeId: number,
    headquarterId: number,
    staffId: number,
    startDate: string,
    endDate: string | null = null,
  ) => {
    this.customerSalesRatioState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
    if (staffId > 0) {
      urlParams.append("staffId", String(staffId));
    }
    if(!(startDate === "" && endDate === "")){
      if(startDate && endDate === null){
        urlParams.append("Date", String(startDate) + " 00:00");
      }
      else{
        urlParams.append("EndDate", String(endDate) + " 00:00");
        urlParams.append("StartDate", String(startDate) + " 00:00");
      }
    }

    const url =
      URLConstants.GetCustomerSalesRatio +
      "?" +
      urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ICustomerSalesRatioVM>>) => {
        if (response.data.Error) {
          this.customerSalesRatioState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.customerSalesRatio = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.customerSalesRatioState.error = err;
      })
      .finally(
        action(() => {
          this.customerSalesRatioState.inProgress = false;
        })
      );
  };

  resetCustomerSalesRatioState = () => {
    this.customerSalesRatioState = {
      ...this.initialStateValue,
    };
    this.customerSalesRatio = {...customerSalesRatioInitialState}
  };

  get getCustomerSalesRatio(): ICustomerSalesRatioList[] {
  if (!this.customerSalesRatio) return [];

  return (Object.keys(this.customerSalesRatio) as (keyof ICustomerSalesRatioVM)[])
    .map((key,index) => {
      const item = this.customerSalesRatio[key];
      if(item)
        return {
          Id: index,
          ColumnName: key,
          NumberOfPeopleMale: item.NumberOfPeopleMale,
          NumberOfPeopleMalePercentage: item.NumberOfPeopleMalePercentage,
          AverageCustomerSpendingMale: item.AverageCustomerSpendingMale,
          NumberOfPeopleFemale: item.NumberOfPeopleFemale,
          NumberOfPeopleFemalePercentage: item.NumberOfPeopleFemalePercentage,
          AverageCustomerSpendingFemale: item.AverageCustomerSpendingFemale,
          NumberOfPeopleNotSet: item.NumberOfPeopleNotSet,
          NumberOfPeopleNotSetPercentage: item.NumberOfPeopleNotSetPercentage,
          AverageCustomerSpendingNotSet: item.AverageCustomerSpendingNotSet,
        } as ICustomerSalesRatioList;
      else 
        return {...initialCustomerSalesRatioAccordingToAgeGroupData, Id: index, ColumnName: key}

    });
  }

  GetWeeklySalesDetailCountService = (
    storeId: number,
    headquarterId: number,
    staffId: number,
    startDate: string,
    endDate: string,
  ) => {
    this.weeklySalesDetailCountState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
    if (staffId > 0) {
      urlParams.append("staffId", String(staffId));
    }
    urlParams.append("EndDate", String(endDate) + " 00:00");
    urlParams.append("StartDate", String(startDate) + " 00:00");
    const url =
      URLConstants.GetWeeklySalesDetail +
      "?" +
      urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ISaleDetailVM[]>>) => {
        if (response.data.Error) {
          this.weeklySalesDetailCountState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.weeklySalesDetailCount = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.weeklySalesDetailCountState.error = err;
      })
      .finally(
        action(() => {
          this.weeklySalesDetailCountState.inProgress = false;
        })
      );
  };

  resetWeeklySalesDetailCountState = () => {
    this.weeklySalesDetailCountState = {...this.initialStateValue};
    this.weeklySalesDetailCount = [];
  };

  get getweeklySalesDetailCount(): ISaleDetailVMList[] {
    if (this.weeklyTotallingFilter?.StartDate && this.weeklyTotallingFilter?.EndDate) {
      
      const startDate = dayjs(this.weeklyTotallingFilter.StartDate);
      const endDate = dayjs(this.weeklyTotallingFilter.EndDate);

      const allDates: string[] = [];
      let current = startDate.clone();
      while (current.isBefore(endDate) || current.isSame(endDate, "day")) {
        allDates.push(current.format(DATE_FORMAT));
        current = current.add(1, "day");
      }

      const apiMap: Record<string, ISaleDetailVM> = {};
      if (this.weeklySalesDetailCount && this.weeklySalesDetailCount.length > 0) {
        this.weeklySalesDetailCount.forEach((saleDetail: ISaleDetailVM) => {
          apiMap[moment(saleDetail.Date).format(DATE_FORMAT)] = saleDetail;
        });
      }

      const data: ISaleDetailVMList[] = allDates.map((date, index) => {
        const saleDetail = apiMap[date];
        return {
          Id: index + 1,
          Date: date,
          TotalSales: saleDetail ? saleDetail.TotalSales : 0,
          TotalNumberOfCustomer: saleDetail ? saleDetail.TotalNumberOfCustomer : 0,
          TreatmentSales: saleDetail ? saleDetail.TreatmentSales : 0,
          ProductSales: saleDetail ? saleDetail.ProductSales : 0,
          DiscountTreatment: saleDetail ? saleDetail.DiscountTreatment : 0,
          DiscountProduct: saleDetail ? saleDetail.DiscountProduct : 0,
        };
      });

      const sum = (field: keyof ISaleDetailVMList): number =>
        data.reduce((acc, curr) => acc + (curr[field] ? Number(curr[field]) : 0), 0);

      const totalRow: ISaleDetailVMList = {
        Id: data.length + 1,
        Date: formatMessage("total"),
        TotalSales: sum("TotalSales"),
        TotalNumberOfCustomer: sum("TotalNumberOfCustomer"),
        TreatmentSales: sum("TreatmentSales"),
        ProductSales: sum("ProductSales"),
        DiscountTreatment: sum("DiscountTreatment"),
        DiscountProduct: sum("DiscountProduct"),
      };

      return [...data, totalRow];
    }

    return [];
  }
  
  get getMonthlySalesDetailCount(): ISaleDetailVMList[] {
    if (this.monthlyTotallingFilter?.MonthYear) {
      
      const startDate = dayjs(this.monthlyTotallingFilter.MonthYear).startOf("month");
      const endDate = dayjs(this.monthlyTotallingFilter.MonthYear).endOf("month");

      const allDates: string[] = [];
      let current = startDate.clone();
      while (current.isBefore(endDate) || current.isSame(endDate, "day")) {
        allDates.push(current.format(DATE_FORMAT));
        current = current.add(1, "day");
      }

      const apiMap: Record<string, ISaleDetailVM> = {};
      if (this.weeklySalesDetailCount && this.weeklySalesDetailCount.length > 0) {
        this.weeklySalesDetailCount.forEach((saleDetail: ISaleDetailVM) => {
          apiMap[moment(saleDetail.Date).format(DATE_FORMAT)] = saleDetail;
        });
      }

      const data: ISaleDetailVMList[] = allDates.map((date, index) => {
        const saleDetail = apiMap[date];
        return {
          Id: index + 1,
          Date: date,
          TotalSales: saleDetail ? saleDetail.TotalSales : 0,
          TotalNumberOfCustomer: saleDetail ? saleDetail.TotalNumberOfCustomer : 0,
          TreatmentSales: saleDetail ? saleDetail.TreatmentSales : 0,
          ProductSales: saleDetail ? saleDetail.ProductSales : 0,
          DiscountTreatment: saleDetail ? saleDetail.DiscountTreatment : 0,
          DiscountProduct: saleDetail ? saleDetail.DiscountProduct : 0,
        };
      });

      const sum = (field: keyof ISaleDetailVMList): number =>
        data.reduce((acc, curr) => acc + (curr[field] ? Number(curr[field]) : 0), 0);

      const totalRow: ISaleDetailVMList = {
        Id: data.length + 1,
        Date: formatMessage("total"),
        TotalSales: sum("TotalSales"),
        TotalNumberOfCustomer: sum("TotalNumberOfCustomer"),
        TreatmentSales: sum("TreatmentSales"),
        ProductSales: sum("ProductSales"),
        DiscountTreatment: sum("DiscountTreatment"),
        DiscountProduct: sum("DiscountProduct"),
      };

      return [...data, totalRow];
    }

  return [];
}


  GetWeeklySalesAndPaymentDetailService = (
    storeId: number,
    headquarterId: number,
    staffId: number,
    startDate: string,
    endDate: string,
  ) => {
    this.weeklySalesAndPaymentDetailState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
     if (staffId > 0) {
      urlParams.append("staffId", String(staffId));
    }
    urlParams.append("EndDate", String(endDate) + " 00:00");
    urlParams.append("StartDate", String(startDate) + " 00:00");
    const url =
      URLConstants.GetWeeklySalesAndPaymentDetail +
      "?" +
      urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IWeeklySalesAndPaymentDetailVM[]>>) => {
        if (response.data.Error) {
          this.weeklySalesAndPaymentDetailState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.weeklySalesAndPaymentDetail = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.weeklySalesAndPaymentDetailState.error = err;
      })
      .finally(
        action(() => {
          this.weeklySalesAndPaymentDetailState.inProgress = false;
        })
      );
  };

  resetWeeklySalesAndPaymentDetailState = () => {
    this.weeklySalesAndPaymentDetailState = {...this.initialStateValue};
    this.weeklySalesAndPaymentDetail = [];
  };

  get getWeeklySalesAndPaymentDetail(): IWeeklySalesAndPaymentDetailVMRow[] {
    if (!this.weeklySalesAndPaymentDetail) return [];

    const startDate = dayjs(this.weeklyTotallingFilter.StartDate);
    const endDate = dayjs(this.weeklyTotallingFilter.EndDate);

    // collect all payment keys
    const allPaymentKeys = Array.from(
      new Set(
        this.weeklySalesAndPaymentDetail.flatMap((item) =>
          item.PaymentVMs.map((p) => p.Name.toLowerCase())
        )
      )
    );

    // index existing data by date
    const dataByDate: Record<string, IWeeklySalesAndPaymentDetailVMRow> = {};
    this.weeklySalesAndPaymentDetail.forEach((item) => {
      const payments: Record<string, number> = {};
      allPaymentKeys.forEach((key) => (payments[key] = 0));

      item.PaymentVMs.forEach((p) => {
        const key = p.Name.toLowerCase();
        payments[key] = (payments[key] || 0) + p.Amount;
      });

      const formattedDate = moment(item.Date).format(DATE_FORMAT);

      dataByDate[formattedDate] = {
        Date: formattedDate,
        TotalSales: item.TotalSales,
        AvgTotalSales: item.AverageTotalSales,
        TotalCustomers: item.TotalNumberOfCustomer,
        TreatmentSales: item.TreatmentSales,
        AvgTreatmentSales: item.AverageTreatmentSales,
        ProductSales: item.ProductSales,
        AvgProductSales: item.AverageProductSales,
        Discount: item.Discount,
        TaxAmount: item.TotalTaxAmount,
        Payments: payments,
      };
    });

    // build rows for each date in range
    const rows: IWeeklySalesAndPaymentDetailVMRow[] = [];
    let current = startDate.clone();

    while (current.isSameOrBefore(endDate, "day")) {
      const formattedDate = current.format(DATE_FORMAT);

      if (dataByDate[formattedDate]) {
        rows.push(dataByDate[formattedDate]);
      } else {
        rows.push({
          Date: formattedDate,
          TotalSales: 0,
          AvgTotalSales: 0,
          TotalCustomers: 0,
          TreatmentSales: 0,
          AvgTreatmentSales: 0,
          ProductSales: 0,
          AvgProductSales: 0,
          Discount: 0,
          TaxAmount: 0,
          Payments: Object.fromEntries(allPaymentKeys.map((k) => [k, 0])),
        });
      }

      current = current.add(1, "day");
    }

    // totals row
    const totals = rows.reduce(
      (acc, row) => {
        acc.TotalSales += row.TotalSales;
        acc.AvgTotalSales += row.AvgTotalSales;
        acc.TotalCustomers += row.TotalCustomers;
        acc.TreatmentSales += row.TreatmentSales;
        acc.AvgTreatmentSales += row.AvgTreatmentSales;
        acc.ProductSales += row.ProductSales;
        acc.AvgProductSales += row.AvgProductSales;
        acc.Discount += row.Discount;
        acc.TaxAmount += row.TaxAmount;

        Object.keys(row.Payments).forEach((k) => {
          acc.Payments[k] = (acc.Payments[k] || 0) + row.Payments[k];
        });

        return acc;
      },
      {
        Date: formatMessage("total"),
        TotalSales: 0,
        AvgTotalSales: 0,
        TotalCustomers: 0,
        TreatmentSales: 0,
        AvgTreatmentSales: 0,
        ProductSales: 0,
        AvgProductSales: 0,
        Discount: 0,
        TaxAmount: 0,
        Payments: Object.fromEntries(allPaymentKeys.map((k) => [k, 0])),
      }
    );
    // calculate averages after totals are accumulated
    const c = totals.TotalCustomers;
    totals.AvgTotalSales = c > 0 ? Math.round(totals.TotalSales / c) : 0;
    totals.AvgTreatmentSales = c > 0 ? Math.round(totals.TreatmentSales / c) : 0;
    totals.AvgProductSales = c > 0 ? Math.round(totals.ProductSales / c) : 0;
    return [...rows, totals];
  }

  
  get getMonthlySalesAndPaymentDetail(): IWeeklySalesAndPaymentDetailVMRow[] {
    if (!this.weeklySalesAndPaymentDetail) return [];

    const startDate = dayjs(this.monthlyTotallingFilter.MonthYear).startOf("month");
    const endDate = dayjs(this.monthlyTotallingFilter.MonthYear).endOf("month");

    // collect all payment keys from available data
    const allPaymentKeys = Array.from(
      new Set(
        this.weeklySalesAndPaymentDetail.flatMap((item) =>
          item.PaymentVMs.map((p) => p.Name.toLowerCase())
        )
      )
    );


    const dataByDate: Record<string, IWeeklySalesAndPaymentDetailVMRow> = {};
    this.weeklySalesAndPaymentDetail.forEach((item) => {
      const payments: Record<string, number> = {};
      allPaymentKeys.forEach((key) => (payments[key] = 0));

      item.PaymentVMs.forEach((p) => {
        const key = p.Name.toLowerCase();
        payments[key] = (payments[key] || 0) + p.Amount;
      });

      const formattedDate = moment(item.Date).format(DATE_FORMAT);

      dataByDate[formattedDate] = {
        Date: formattedDate,
        TotalSales: item.TotalSales,
        AvgTotalSales: item.AverageTotalSales,
        TotalCustomers: item.TotalNumberOfCustomer,
        TreatmentSales: item.TreatmentSales,
        AvgTreatmentSales: item.AverageTreatmentSales,
        ProductSales: item.ProductSales,
        AvgProductSales: item.AverageProductSales,
        Discount: item.Discount,
        TaxAmount: item.TotalTaxAmount,
        Payments: payments,
      };
    });

    // generate rows for each date in range
    const rows: IWeeklySalesAndPaymentDetailVMRow[] = [];
    let current = startDate.clone();

    while (current.isSameOrBefore(endDate, "day")) {
      const formattedDate = current.format(DATE_FORMAT);
      if (dataByDate[formattedDate]) {
        rows.push(dataByDate[formattedDate]);
      } else {
        // push empty row with 0 values
        rows.push({
          Date: formattedDate,
          TotalSales: 0,
          AvgTotalSales: 0,
          TotalCustomers: 0,
          TreatmentSales: 0,
          AvgTreatmentSales: 0,
          ProductSales: 0,
          AvgProductSales: 0,
          Discount: 0,
          TaxAmount: 0,
          Payments: Object.fromEntries(allPaymentKeys.map((k) => [k, 0])),
        });
      }
      current = current.add(1, "day");
    }

    // calculate totals
    const totals = rows.reduce(
      (acc, row) => {
        acc.TotalSales += row.TotalSales;
        acc.AvgTotalSales += row.AvgTotalSales;
        acc.TotalCustomers += row.TotalCustomers;
        acc.TreatmentSales += row.TreatmentSales;
        acc.AvgTreatmentSales += row.AvgTreatmentSales;
        acc.ProductSales += row.ProductSales;
        acc.AvgProductSales += row.AvgProductSales;
        acc.Discount += row.Discount;
        acc.TaxAmount += row.TaxAmount;

        Object.keys(row.Payments).forEach((k) => {
          acc.Payments[k] = (acc.Payments[k] || 0) + row.Payments[k];
        });

        return acc;
      },
      {
        Date: formatMessage("total"),
        TotalSales: 0,
        AvgTotalSales: 0,
        TotalCustomers: 0,
        TreatmentSales: 0,
        AvgTreatmentSales: 0,
        ProductSales: 0,
        AvgProductSales: 0,
        Discount: 0,
        TaxAmount: 0,
        Payments: Object.fromEntries(allPaymentKeys.map((k) => [k, 0])),
      }
    );
    const c = totals.TotalCustomers;
    totals.AvgTotalSales = c > 0 ? Math.round(totals.TotalSales / c) : 0;
    totals.AvgTreatmentSales = c > 0 ? Math.round(totals.TreatmentSales / c) : 0;
    totals.AvgProductSales = c > 0 ? Math.round(totals.ProductSales / c) : 0;

    return [...rows, totals];
  }


  setDailyTotallingFilterDetail = (filter: IDailyTotallingFilter) => {
    this.dailyTotallingFilter = { ...filter };
  };

  resetDailyTotallingFilterDetail = () => {
    this.dailyTotallingFilter = {
      Date: getEffectiveDateTime(),
      StaffId: -1,
      isFilterActive: false,
      isFilterChanged: false,
      showClear: false,
    };
  };
  
  setMonthlyTotallingFilterDetail = (filter: IMonthlyTotallingFilter) => {
    this.monthlyTotallingFilter = { ...filter };
  };

  resetMonthlyTotallingFilterDetail = () => {
    this.monthlyTotallingFilter = {
      MonthYear: getEffectiveMonthYear(),
      StaffId: -1,
      isFilterActive: false,
      isFilterChanged: false,
      showClear: false,
    };
  };

  setWeeklyTotallingFilterDetail = (filter: IWeeklyTotallingFilter) => {
    this.weeklyTotallingFilter = { ...filter };
  };

  resetWeeklyTotallingFilterDetail = () => {
    this.weeklyTotallingFilter = {
      StartDate: moment(new Date()).format(DATE_FORMAT),
      EndDate: moment(new Date()).add(6, "days").format(DATE_FORMAT),
      StaffId: -1,
      isFilterActive: false,
      isFilterChanged: false,
      showClear: false,
    };
  };

  setPeriodTotallingFilterDetail = (filter: IWeeklyTotallingFilter) => {
    this.periodTotallingFilter = { ...filter };
  };

  resetPeriodTotallingFilterDetail = () => {
    this.periodTotallingFilter = {
      StartDate: "",
      EndDate: "",
      StaffId: -1,
      isFilterActive: false,
      isFilterChanged: false,
      showClear: false,
    };
  };
  
  GetStaffSalesDetailService = (
    storeId: number,
    headquarterId: number,
    staffId: number,
    startDate: string,
    endDate: string,
  ) => {
    this.staffSalesDetailState.inProgress = true;
    const urlParams = new URLSearchParams();
    if (storeId > 0) {
      urlParams.append("StoreId", String(storeId));
    }
    if (headquarterId > 0) {
      urlParams.append("HeadquarterId", String(headquarterId));
    }
     if (staffId > 0) {
      urlParams.append("staffId", String(staffId));
    }
    urlParams.append("EndDate", String(endDate) + " 00:00");
    urlParams.append("StartDate", String(startDate) + " 00:00");
    const url = URLConstants.GetStaffSalesDetail + "?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IStaffSalesDetailVM[]>>) => {
        if (response.data.Error) {
          this.staffSalesDetailState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.staffSalesDetail = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.staffSalesDetailState.error = err;
      })
      .finally(
        action(() => {
          this.staffSalesDetailState.inProgress = false;
        })
      );
  };

  resetStaffSalesDetailState = () => {
    this.staffSalesDetailState = {...this.initialStateValue};
    this.staffSalesDetail = [];
  };

  get getStaffSalesDetail(): IStaffSalesDetailList[] {
    if (this.staffSalesDetail && this.staffSalesDetail.length > 0)
      return this.staffSalesDetail.map((staff, index) => {
        let language = getLanguageFromLocalStorage();
        return {
          Id: index,
          StaffName: staff.StaffName ?? "",
          TotalSales: staff.TotalSales,
          TotalNumberOfCustomer: staff.TotalNumberOfCustomer,
          TreatmentSales: staff.TreatmentSales,
          ProductSales: staff.ProductSales,
          UnitPrice: staff.UnitPrice,
          NominatedCustomer: staff.NominatedCustomer,
          Language: language,
          NominatedCustomerPercentage: staff.NominatedCustomerPercentage
        }
      })
  return [];
  }

  setStaffTotallingFilterDetail = (filter: IStaffTotallingFilter) => {
    this.staffTotallingFilter = { ...filter };
  };

  resetStaffTotallingFilterDetail = () => {
    this.staffTotallingFilter = {
      StartDate: moment(new Date()).format(DATE_FORMAT),
      EndDate: moment(new Date()).add(6, "days").format(DATE_FORMAT),
      StaffId: -1,
      isFilterActive: false,
      isFilterChanged: false,
      showClear: false,
    };
  };

}

export default new TotallingManagementStore();
